import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Menu as MenuIcon,
  CheckCircle,
  LibraryBooks,
  Settings,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const isTechnicianChecklistPage =
    location.pathname === "/checklist" && location.search;

  const menuItems = [
    // { text: "Checklists", icon: <CheckCircle />, path: "/" },
    { text: "Templates", icon: <LibraryBooks />, path: "/templates" },
  ];

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  return (
    <>
      <AppBar position="static" elevation={0}>
        <Toolbar>
          {/* {isMobile && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )} */}
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Checklist App
          </Typography>

          {!isMobile && (
            <Box sx={{ display: "flex" }}>
              {!isTechnicianChecklistPage &&
                menuItems.map((item) => (
                  <Button
                    key={item.text}
                    color="inherit"
                    component={Link}
                    to={item.path}
                    startIcon={item.icon}
                    sx={{ mx: 1 }}
                  >
                    {item.text}
                  </Button>
                ))}
            </Box>
          )}

          {/* <IconButton color="inherit" aria-label="settings">
            <Settings />
          </IconButton> */}
        </Toolbar>
      </AppBar>

      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <List>
            {!isTechnicianChecklistPage &&
              menuItems.map((item) => (
                <ListItem
                  button
                  key={item.text}
                  component={Link}
                  to={item.path}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItem>
              ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default Header;
